import { render, staticRenderFns } from "./footerBlock.vue?vue&type=template&id=082af9b2"
import script from "./footerBlock.vue?vue&type=script&lang=js"
export * from "./footerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports